import { Widget } from "@rjsf/utils";

import { TitleWidget } from "./TitleWidget";
import { ParagraphWidget } from "./ParagraphWidget";
import { SubtitleWidget } from "./SubtitleWidget";
import { MarkdownTextWidget } from "./MarkdownTextWidget";
import { UnlimitedCheckboxWidget } from "./UnlimitedCheckboxWidget";

interface WidgetRegistry {
  [name: string]: Widget;
}

export const UnlimitedWidgets: WidgetRegistry = {
  limitedCheckbox: UnlimitedCheckboxWidget,
  title: TitleWidget,
  subtitle: SubtitleWidget,
  paragraph: ParagraphWidget,
  markdownText: MarkdownTextWidget
};
